<script>
	// TODO: refactor to SuperForm SuperInput component "InputFile"
	let {
		form,
		inputName = 'images',
		class: className = '',
		required,
	} = $props();
	const { form: innerForm } = $derived(form);
	async function handleFileInput(e) {
		const files = Array.from(e.target.files ?? []).filter(
			(file) => file instanceof File,
		);
		if (!files.length) {
			return;
		}
		try {
			await Promise.all(files.map(getFileBlob));
		} catch (error) {
			console.error(error);
		} finally {
			$innerForm[inputName] = files.filter(
				(file) => file && file.src && file.name,
			);
		}
	}
	async function getFileBlob(file) {
		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = (event) => {
				file.src = event.target.result;
				return resolve(file);
			};
		});
	}
</script>

<div class={['mb-4 grid w-full gap-x-4', className ?? ''].join(' ')}>
	<label
		class="relative col-span-full grid place-items-start content-between gap-2"
	>
		<span>If you have photos of your window frames please upload them!</span>
		<input
			{required}
			type="file"
			multiple
			name={inputName}
			accept="image/*"
			oninput={async (e) => await handleFileInput(e)}
			class="w-full rounded-md border border-indow-grey-light p-2"
		/>

		{#if $innerForm?.[inputName]}
			<div class="flex flex-wrap gap-4">
				{#each Array.from($innerForm?.[inputName]) ?? [] as img, i (i)}
					{#if img?.src && img?.name}
						<img src={img.src} alt={img.name} class="h-32 w-auto rounded-lg" />
					{/if}
				{/each}
			</div>
		{/if}
		{#if form.$errors?.images}
			<div class="col-span-full mb-4">
				<p class="text-left text-indow-red">Image Upload Error:</p>
			</div>
			{#each Array.from(Object.values(form.$errors?.[inputName])) as error, i (i)}
				<div class="col-span-full mb-4">
					<p class="mb-0 text-left">{$innerForm?.[inputName][i]?.name}</p>
					<p class="text-left text-indow-red">
						{error}
					</p>
				</div>
			{/each}
		{/if}
	</label>
</div>
